"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _Tooltip = require("../../atoms/Tooltip");

var _deviceUtils = require("../../utils/deviceUtils");

var _default = function _default(WrappedComponent, tooltipConfiguration) {
  var WithTooltip = function WithTooltip(_ref) {
    var props = (0, _extends2.default)({}, _ref);

    var _useState = (0, _react.useState)(false),
        _useState2 = (0, _slicedToArray2.default)(_useState, 2),
        tooltipVisibility = _useState2[0],
        setTooltipVisibility = _useState2[1];

    var _useState3 = (0, _react.useState)({
      x: 100,
      y: 50
    }),
        _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
        relativeElementPosition = _useState4[0],
        setRelativeElementPosition = _useState4[1];

    var tooltipComponentRef = (0, _react.useRef)();

    var _useState5 = (0, _react.useState)(),
        _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
        isDesktopView = _useState6[0],
        setDesktopView = _useState6[1];

    var position = tooltipConfiguration.position,
        message = tooltipConfiguration.message,
        id = tooltipConfiguration.id;
    var tooltipVisibleRef = (0, _react.useRef)(tooltipVisibility);

    var updateTooltipVisible = function updateTooltipVisible(data) {
      tooltipVisibleRef.current = data;
      setTooltipVisibility(data);
    };

    var handleOnMouseLeave = function handleOnMouseLeave(_ref2) {
      var _tooltipComponentRef$;

      var target = _ref2.target;

      if (isDesktopView && (_tooltipComponentRef$ = tooltipComponentRef.current) !== null && _tooltipComponentRef$ !== void 0 && _tooltipComponentRef$.contains(target)) {
        updateTooltipVisible(false);
      }
    };

    var setTooltipVisible = function setTooltipVisible(event) {
      var element = event.currentTarget;

      if (element != null) {
        var elementRect = element.getBoundingClientRect();
        setRelativeElementPosition(elementRect);
        updateTooltipVisible(true);
      }
    };

    var handleOnMouseOver = function handleOnMouseOver(event) {
      if (isDesktopView && !tooltipVisibleRef.current) {
        setTooltipVisible(event);
      }
    };

    var handleWrappedComponentClick = function handleWrappedComponentClick(event) {
      setTooltipVisible(event);
      event.preventDefault();
      event.stopPropagation();
    };

    var handleDocumentClick = function handleDocumentClick(_ref3) {
      var _tooltipComponentRef$2;

      var target = _ref3.target;

      if (!isDesktopView && !((_tooltipComponentRef$2 = tooltipComponentRef.current) !== null && _tooltipComponentRef$2 !== void 0 && _tooltipComponentRef$2.contains(target)) && tooltipVisibleRef.current === true) {
        updateTooltipVisible(false);
      }
    };

    (0, _react.useLayoutEffect)(function () {
      var listener = function listener() {
        setDesktopView((0, _deviceUtils.isDesktop)());
      };

      window.addEventListener('resize', listener);
      return function () {
        window.removeEventListener('resize', listener);
      };
    }, []);
    (0, _react.useEffect)(function () {
      setDesktopView((0, _deviceUtils.isDesktop)());
      document.addEventListener('mousedown', handleDocumentClick);
      document.addEventListener('touchstart', handleDocumentClick);
      return function () {
        document.removeEventListener('mousedown', handleDocumentClick);
        document.removeEventListener('touchstart', handleDocumentClick);
      };
    }, []);
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
      ref: tooltipComponentRef
    }, _react.default.createElement(WrappedComponent, (0, _extends2.default)({
      onMouseOver: handleOnMouseOver,
      onMouseLeave: handleOnMouseLeave,
      onClick: handleWrappedComponentClick,
      onFocus: function onFocus() {},
      onBlur: function onBlur() {}
    }, props))), tooltipVisibility && _react.default.createElement(_Tooltip.Tooltip, {
      relativeElementPosition: relativeElementPosition,
      position: position,
      message: message,
      id: id
    }));
  };

  return WithTooltip;
};

exports.default = _default;